import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AccessTokenQueryKey } from "utils/oauth";
import { useSetUrlSearchParams, useUrlQueryParam } from "utils/url";
import Cookie from "js-cookie";

// export const AUTH_API_URL = process.env.REACT_APP_API_URL_AUTH
export const AUTH_API_URL = process.env.REACT_APP_API_URL_AUTH || "";

export const APP_API_URL = process.env.REACT_APP_API_URL || "";

export const DEVICE_TYPE_KEY = "device_type";

export const PROJECT_CLIENT_ID = process.env.REACT_APP_CLIENT_ID || "";

export const StorageMobile = (
  type: "get" | "set" | "remove",
  mobile?: string
) => {
  if (type === "get") {
    return window.localStorage.getItem("mobile");
  } else if (type === "set") {
    window.localStorage.setItem("mobile", mobile || "");
  } else {
    localStorage.removeItem("mobile");
  }
};

export type ModelType = "join" | "verify" | "login";

export const useProjectModal = () => {
  // originFrom 目前仅对 verify弹框时，显示文案有用
  const [{ modelType, originFrom, onboarding }, setModelType] = useUrlQueryParam([
    "modelType",
    "originFrom",
    "onboarding",
  ]);

  const setUrlParams = useSetUrlSearchParams();
  // 打开验证手机号弹框时，带上第二个参数，标识是从 login 还是 join打开
  const open = (val: string, from: string) =>
    setModelType({ modelType: val, originFrom: from });
  const close = () => setUrlParams({ modelType: "", originFrom: "" });
  if (onboarding === 'true') {
    // setModelType({ modelType: '', originFrom });
  }
  return {
    // 从 url 获取到的变量，都是string类型
    projectModalOpen: !!modelType,
    modelType,
    originFrom,
    open,
    close,
  };
};

const isVoid = (value: unknown) =>
  value === null || value === undefined || value === "";

// obj是键值对，键是string类型key，值unknown
export const clearParam = (obj: { [key: string]: unknown }) => {
  const result = { ...obj };
  Object.keys(obj).forEach((key) => {
    if (isVoid(obj[key])) {
      delete result[key];
    }
  });
  return result;
};

export const useMount = (callback: () => void) => {
  useEffect(() => {
    callback();
  }, [callback]);
};

// 新注册后的code，加分号拼到后面
export const checkAndSetRestaurantInfo = (
  type: "get" | "set" | "remove",
  phoneKey: string,
  newCode?: string
) => {
  const str = window.localStorage.getItem(phoneKey) || "";
  if (type === "get") {
    // 是否注册过
    return str.includes(`${newCode};`);
  } else if (type === "set") {
    // 没存储过，存一下
    if (!str.includes(`${newCode};`)) {
      window.localStorage.setItem(phoneKey, `${str}${newCode};`);
    }
  } else {
    // 移除注册餐厅code
    const reg = new RegExp(`${newCode};`);
    const newStr = str.replace(reg, "");
    window.localStorage.setItem(phoneKey, newStr);
  }
};

// 查看token和切换到restaurant
export const useRedirectUrl = (phoneKey: string, newCode: string) => {
  const route = useLocation();
  const hasRegistered = checkAndSetRestaurantInfo("get", phoneKey, newCode);
  if (
    route.pathname !== "/restaurant" &&
    hasRegistered &&
    localStorage.getItem(AccessTokenQueryKey)
  ) {
    return { redirect: true };
  } else {
    return { redirect: false };
  }
};

export const checkRepeatRegister = (e: any) => {
  try {
    if (typeof e !== "object" || !e.errors || !Array.isArray(e.errors)) {
      return false;
    }
    const [responseInfo] = e.errors;
    const { code = "" } = responseInfo;
    return code === "LOYALTY_RESTAURANT_MEMBER_001";
  } catch (error) {
    return false;
  }
};

const getSetVal = (originVal: string, targetVal: string) => {
  return originVal.includes(`${targetVal}`)
    ? originVal
    : `${originVal}${targetVal}&`;
};

export const setIsMemberCookie = (
  itemKey: string,
  itemVal: string,
  expires = 365 * 10
) => {
  const originVal = Cookie.get(itemKey) || "";
  const result = !originVal ? `${itemVal}&` : getSetVal(originVal, itemVal);
  Cookie.set(itemKey, result, {
    secure: false,
    expires,
    domain: ".chowbus.com",
  });
};

export const getCookie = (name: string) => {
  return Cookie.get(name);
};

export const setCookie = (itemKey: string, itemVal: string, expires = 365) => {
  Cookie.set(itemKey, itemVal, {
    secure: false,
    expires,
    domain: ".chowbus.com",
  });
};

export const removeCookie = (itemKey: string) => {
  Cookie.remove(itemKey);
};

export const sendMessageToParent = (
  messageObj: {
    type: string;
    data: unknown;
  },
  source = ""
) => {
  if (source !== "smart_ordering") {
    return;
  }
  const message = JSON.stringify(messageObj);
  window.parent?.postMessage(message, "*");
};
